<bp-modal-header
  class="font-semibold"
  [title]="(readonly ? 'direct_debit_mandate_title' : 'direct_debit_confirmation_title') | translate">
  @if (showBackButton) {
    <a
      left
      (click)="onButtonClick('back')"
      (keydown.enter)="onButtonClick('back')"
      [tabIndex]="0"
      >
      {{ "back" | translate }}
    </a>
  }
  <a right (click)="onButtonClick('abort')" (keydown.enter)="onButtonClick('abort')" [tabIndex]="0">
    {{ (readonly ? "close" : "abort") | translate }}
  </a>
</bp-modal-header>
<div class="bp-modal-body">
  <div class="bp-modal-body-section mod-fullwidth">
    <div class="text-big-black text-center font-size-24 mt-10 large-weight">
      {{ "direct_debit_mandate_id" | translate: [account?.getShortId()] }}
    </div>
    <div class="data mod-input mt-30">
      <div class="details">
        <div class="flex flex-col">
          <span class="section-title font-bold font-size-17">{{ "user_data_bank_account" | translate }}</span>
          @if (getBankAccountDetails(); as details) {
            <span>{{ details.getHolder() }}</span>
            <span>{{ details.getIban() }}</span>
            <span>{{ details.getBankName() }}</span>
            <span>{{ details.getBic() }}</span>
          }
        </div>
        <div class="flex flex-col mt-20">
          <span class="section-title font-bold font-size-17">{{ "user_data_address" | translate }}</span>
          @if (account; as acc) {
            <span>{{ acc.getStreet() }}</span>
            <span>{{ acc.getZip() }} {{ acc.getCity() }}</span>
            <span>{{ getCountry()?.getName() }}</span>
          }
        </div>
      </div>
      <div class="details">
        <div class="flex flex-col">
          <span class="section-title font-bold font-size-17">{{ "payment_type" | translate }}</span>
          <span>{{ "recurring_payment" | translate }}</span>
        </div>
        @if (account?.getCreationTime(); as creationTime) {
          <div class="flex flex-col mt-10">
            <span class="section-title font-bold font-size-17">{{ "date_tx_item" | translate }}</span>
            <span>{{ creationTime.getUnix() | bp_date: { time: [] } }}</span>
          </div>
        }
        <div class="flex flex-col mt-10">
          <span class="section-title font-bold font-size-17">
            {{ "direct_debit_payment_recipient" | translate }}
          </span>
          <span>
            {{ "bitpanda_payment_account_name" | translate }}
          </span>
          <span>
            {{ "bitpanda_payment_account_cid" | translate }}
          </span>
          <span>{{ "bitpanda_payment_account_address_1" | translate }}</span>
          <span>{{ "bitpanda_payment_account_address_2" | translate }}</span>
        </div>
      </div>
    </div>
    <div class="terms">
      <div class="font-size-15 mb-15">{{ "direct_debit_terms_and_conditions" | translate }}</div>
      <div class="description font-size-12 mb-15">{{ "direct_debit_refund_request_info" | translate }}</div>
      <div class="description font-size-12">{{ "direct_debit_deduction_announcement_period" | translate }}</div>
      @if (!readonly) {
        <div
          class="mt-40 text-center focus-child"
          (keydown.enter)="onButtonClick('confirm')"
          [tabIndex]="0"
          >
          <button
            class="btn btn-primary btn-lg btn-summary mod-amount"
            type="button"
            (click)="onButtonClick('confirm')">
            {{ "direct_debit_confirmation_button" | translate }}
          </button>
        </div>
      } @else {
        <div class="font-size-16 mt-20 mb-20">
          {{ "direct_debit_revoke_mandate_1" | translate }}
          <a class="underline" [href]="getSupportUrl()" target="_blank">
            {{ "direct_debit_revoke_mandate_2" | translate }}
          </a>
        </div>
      }
    </div>
  </div>
</div>
